/**
 * Import constants
 */
import { GET_ACCEPTANCE_DATA, GET_ACCEPTANCE_DATA_PENDING, GET_ACCEPTANCE_DATA_ERROR } from '../actions/constants';

/**
 * Initial state
 */
const initialState = {
	loading: true,
	data: {},
	error: null
};

/**
 * Acceptance data reducer
 * @param {*} state
 * @param {*} action
 */
export const acceptanceDataReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_ACCEPTANCE_DATA_PENDING:
			return {
				...state,
				loading: true
			};
		case GET_ACCEPTANCE_DATA:
			return {
				...state,
				loading: false,
				data: action.payload,
				error: null
			};
		case GET_ACCEPTANCE_DATA_ERROR:
			return {
				...state,
				loading: true,
				error: action.payload
			};
		default:
			return state;
	}
};
